import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

export default () => ({
    slider: null,
    sliderEl: null,
    currentSlide: 0,
    sliderOptions: {},

    init() {
        this.sliderEl = this.$el.querySelector('.splide-slider');
        if (!this.sliderEl) {
            return;
        }

        const options = this.$el.getAttribute('data-slider-options');
        this.sliderOptions = options ? JSON.parse(options) : {
            type: 'loop',
            perPage: 4,
            autoplay: false,
            interval: 3000,
            pauseOnHover: true,
            pauseOnFocus: true,
            arrows: false,
            pagination: false,
        };

        this.createInstance();
        this.reactOnMove();
    },

    reactOnMove() {
        this.slider.on('moved', (newIndex) => {
            this.currentSlide = newIndex;
        });
    },

    goToSlide(index) {
        this.slider.go(index);
    },

    createInstance() {
        this.slider = new Splide(this.sliderEl, this.sliderOptions);
        const bar = this.slider.root.querySelector('.slider-custom-progress-bar');

        if (bar) {
            this.slider.on('mounted move', () => {
                const end = this.slider.Components.Controller.getEnd() + 1;
                const rate = Math.min((this.slider.index + 1) / end, 1);
                bar.style.width = `${100 * rate}%`;
            });
        }

        this.slider.mount();
        this.handleArrows(this.slider);
    },

    handleArrows(splide) {
        const container = splide.root;
        const prevButton = container.querySelector('.splide__custom--prev');
        const nextButton = container.querySelector('.splide__custom--next');
        if (prevButton && nextButton) {
            prevButton.addEventListener('click', () => {
                splide.go('<');
            });

            nextButton.addEventListener('click', () => {
                splide.go('>');
            });

            splide.on('move', () => {
                const isFirstSlide = splide.index === 0;
                const isLastSlide = splide.index === splide.Components.Controller.getEnd();
                if (isFirstSlide) {
                    prevButton.classList.add('opacity-50');
                    prevButton.classList.add('cursor-default');
                } else {
                    prevButton.classList.remove('opacity-50');
                    prevButton.classList.remove('cursor-default');
                }
                if (isLastSlide) {
                    nextButton.classList.add('opacity-50');
                    nextButton.classList.add('cursor-default');
                } else {
                    nextButton.classList.remove('opacity-50');
                    nextButton.classList.remove('cursor-default');
                }
            });
        }
    },

    reinitializeSlider() {
        if (this.slider) {
            this.slider.destroy();
        }
        this.createInstance();
    }
});
